/**
 * Risk inbox — cross-style "what's at risk" view (garment Increment 9).
 *
 * @see prototype/garment/style-file.html — risk pills baseline
 */
import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceShell } from "../../../../features/workspace/index.ts";
import { RisksInboxPage } from "../../../../features/styles/index.ts";

export const Route = createFileRoute("/(workspace)/merchandising/risks/")({
  component: RisksRoute,
});

function RisksRoute() {
  return (
    <WorkspaceShell breadcrumbs={[{ label: "Merchandising", to: "/" }, { label: "Risks" }]}>
      <RisksInboxPage />
    </WorkspaceShell>
  );
}
